import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useAccountRestrictions } from '@/hooks/use-account-restrictions';
import { PUBLIC_ROUTES } from '@/config/router';

const EXEMPT_PATHS = ['restricted', 'billing', 'setup-payment'];

export function AccessRestrictionGuard() {
    const { hasAccessRestriction, restrictionReason, isLoading, noAccountLinked } = useAccountRestrictions();
    const location = useLocation();
    const { orgSlug } = useParams<{ orgSlug: string }>();

    // Check if current path is exempt
    const currentSegment = location.pathname.split('/').pop() || '';
    const isExempt = EXEMPT_PATHS.some((path) => location.pathname.includes(`/${path}`));

    if (noAccountLinked) {
        return <Navigate to={PUBLIC_ROUTES.NO_ORGANIZATION} replace state={{ noAccountLinked: true }} />;
    }

    if (isExempt || isLoading) {
        return <Outlet />;
    }

    if (hasAccessRestriction && restrictionReason) {
        const restrictedPath = orgSlug
            ? `/org/${orgSlug}/restricted?reason=${restrictionReason}`
            : `/restricted?reason=${restrictionReason}`;
        return <Navigate to={restrictedPath} replace />;
    }

    return <Outlet />;
}
